import { cliente } from './api'
import CryptoJS from 'crypto-js'

// helper para cifrar en formato IV:Cipher (AES-256-CBC)
function cifrarAES(texto) {
  const key = CryptoJS.enc.Hex.parse(process.env.VUE_APP_SECRET_KEY)
  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(texto, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  const ivBase64 = CryptoJS.enc.Base64.stringify(iv)
  const cipherBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64)

  return `${ivBase64}:${cipherBase64}`
}

export default {
  Autenticar() {
    const payload = {
      usuario: process.env.VUE_APP_CREDIGITAL_USUARIO,
      contrasena: process.env.VUE_APP_CREDIGITAL_CONTRASENA,
    }
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      process.env.VUE_APP_SECRET_KEY
    ).toString()
    return cliente.post('Login/autenticar', { payload: encryptedPayload })
  },

  AutenticarV3(numeroSocio = 'DEFAULT') {
    const clave = cifrarAES(String(numeroSocio))
    return cliente.post('Login/autenticar_v3', { clave })
  },

  Ping() {
    return cliente.get('Login/ping')
  },
}
